import axios, { getData } from "lib/axios";

// get all category for employee with balance allocation
export const getAllCategoriesWithBalanceAllocation = () => {
  return axios.get("/expense-categories").then(getData);
};

// get all category for admin
export const getAllCategories = () => {
  return axios.get("/admin/expense-categories").then(getData);
};

export const deleteCategory = async (id) => {
  return axios.delete(`/admin/expense-categories/${id}`).then(getData);
};

export const postNewCategory = async (data) => {
  return axios.post("/admin/expense-categories", data).then(getData);
};

export const putUpdateCategory = async (id, data) => {
  return axios.put(`/admin/expense-categories/${id}`, data).then(getData);
};
